import { Button } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

function PageAccueil() {
	const navigate = useNavigate()
	const [displayText, setDisplayText] = useState("")
	const [isButtonVisible, setIsButtonVisible] = useState(false)
	const textContainerRef = useRef<HTMLDivElement>(null)

	const handleClick = () => {
		navigate("/cvskill/poleCivilite")
	}

	useEffect(() => {
		const fullText = `Bienvenue sur le CV-SKILL ! 👋<br><br>Un nouveau concept développé par Entreprendre Ensemble pour vous aider à créer un CV professionnel qui met en valeur vos <strong class="step-highlight">compétences et votre personnalité</strong>.<br><br><strong>📝 Création en 4 étapes simples :</strong><br><br><strong class="step-highlight">1. Civilité</strong> → Vos informations personnelles<br><strong class="step-highlight">2. Personnalité</strong> → Vos traits de caractère<br><strong class="step-highlight">3. Atouts</strong> → Vos points forts professionnels<br><strong class="step-highlight">4. Centres d'intérêt</strong> → Vos loisirs et passions<br><br><strong>🎨 Personnalisation de votre CV :</strong><br><br>Une fois votre profil complété, vous pourrez :<br>• <strong class="step-highlight">Choisir parmi plusieurs thèmes</strong> graphiques professionnels<br>• <strong class="step-highlight">Ajouter une photo</strong> ou créer un CV sans photo<br>• <strong class="step-highlight">Modifier à tout moment</strong> vos informations de civilité et centres d'intérêt<br>• <strong class="step-highlight">Imprimer votre CV</strong> au format professionnel<br><br><strong>⚠️ Important à savoir :</strong><br><br>Les pôles <strong>Personnalité</strong> et <strong>Atouts</strong> ne pourront plus être modifiés après validation, afin de garantir l'authenticité de votre profil auprès des recruteurs. Seule l'association peut intervenir sur demande justifiée.<br><br>Prêt à créer votre CV-SKILL ? C'est parti ! 🚀<br><br>L'équipe d'Entreprendre Ensemble`
		let index = 0
		const speed = 30 // Vitesse de l'animation en millisecondes

		let typingInterval: NodeJS.Timeout

		function typeWriter() {
			if (index < fullText.length) {
				setDisplayText(prevText => prevText + fullText.charAt(index))
				index += 1
				if (textContainerRef.current) {
					textContainerRef.current.scrollIntoView({
						behavior: "smooth",
						block: "end",
					})
				}
			} else {
				clearInterval(typingInterval)
				setIsButtonVisible(true)
			}
		}

		function showFullText() {
			clearInterval(typingInterval)
			setDisplayText(fullText)
			setIsButtonVisible(true)
		}

		typingInterval = setInterval(typeWriter, speed)

		const handleKeyPress = () => {
			showFullText()
		}

		window.addEventListener("keydown", handleKeyPress)

		return () => {
			clearInterval(typingInterval)
			window.removeEventListener("keydown", handleKeyPress)
		}
	}, [])

	return (
		<div className="container mx-auto p-4 max-w-4xl relative overflow-y-auto h-[calc(100vh-8rem)] pb-16">
			<style>{`
                .container::-webkit-scrollbar {
                    display: none;
                }
                .container {
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                }
                
                .page-header {
                    background: linear-gradient(135deg, #2daf8e 0%, #238f74 100%);
                    color: white;
                    padding: 24px 32px;
                    border-radius: 16px;
                    text-align: center;
                    box-shadow: 0 4px 12px rgba(45, 175, 142, 0.3);
                    margin-bottom: 32px;
                    animation: slideDown 0.5s ease-out;
                }
                
                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .page-header h1 {
                    font-size: 32px;
                    font-weight: 700;
                    margin: 0;
                    letter-spacing: 2px;
                }
                
                .subtitle {
                    font-size: 16px;
                    margin-top: 8px;
                    opacity: 0.95;
                    font-weight: 500;
                }
                
                .content-card {
                    background: white;
                    border: 2px solid #e5e7eb;
                    border-radius: 16px;
                    padding: 32px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    margin-bottom: 24px;
                    position: relative;
                    overflow: hidden;
                }
                
                .content-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 4px;
                    background: linear-gradient(90deg, #2daf8e 0%, #238f74 100%);
                }
                
                .typewriter-text {
                    font-size: 16px;
                    line-height: 1.8;
                    color: #374151;
                    min-height: 200px;
                }
                
                .typewriter-text br {
                    display: block;
                    content: "";
                    margin-top: 8px;
                }
                
                .step-highlight {
                    color: #2daf8e;
                    font-weight: 600;
                }
                
                .action-button {
                    background: linear-gradient(135deg, #2daf8e 0%, #238f74 100%) !important;
                    box-shadow: 0 4px 12px rgba(45, 175, 142, 0.3) !important;
                    text-transform: none !important;
                    font-size: 16px !important;
                    font-weight: 600 !important;
                    padding: 14px 32px !important;
                    border-radius: 12px !important;
                    transition: all 0.3s ease !important;
                    animation: fadeIn 0.5s ease-out;
                }
                
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .action-button:hover {
                    transform: translateY(-2px) !important;
                    box-shadow: 0 6px 16px rgba(45, 175, 142, 0.4) !important;
                }
                
                .info-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: #f0fdf4;
                    border: 2px solid #86efac;
                    color: #166534;
                    padding: 8px 16px;
                    border-radius: 20px;
                    font-size: 13px;
                    font-weight: 600;
                    margin-bottom: 24px;
                }
                
                .cursor-blink {
                    display: inline-block;
                    width: 2px;
                    height: 1em;
                    background-color: #2daf8e;
                    margin-left: 2px;
                    animation: blink 1s infinite;
                }
                
                @keyframes blink {
                    0%, 50% { opacity: 1; }
                    51%, 100% { opacity: 0; }
                }
                
                .skip-hint {
                    text-align: center;
                    color: #9ca3af;
                    font-size: 14px;
                    margin-top: 16px;
                    font-style: italic;
                }
            `}</style>

			<div className="page-header">
				<h1>CV-SKILL</h1>
				<div className="subtitle">
					Votre profil professionnel nouvelle génération
				</div>
			</div>

			<div className="info-badge">
				<span>💡</span>
				<span>
					Appuyez sur n'importe quelle touche pour afficher le texte
					complet
				</span>
			</div>

			<div className="content-card">
				<div
					id="typewriter"
					className="typewriter-text"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html:
							displayText +
							(isButtonVisible
								? ""
								: '<span class="cursor-blink"></span>'),
					}}
					ref={textContainerRef}
				/>
			</div>

			{isButtonVisible && (
				<>
					<div className="flex justify-center">
						<Button
							variant="contained"
							onClick={handleClick}
							type="button"
							className="action-button"
						>
							🚀 Passons à l'étape de création de votre CV-SKILL
						</Button>
					</div>

					<div className="skip-hint">
						Cliquez sur le bouton pour commencer votre CV-SKILL
					</div>
				</>
			)}
		</div>
	)
}

export default PageAccueil
